import React from 'react'
import styles from "../vendorprofile/myprofile.module.css"
import VenOrderscomp from '../../Components/orderscomp/VenOrderscomp'
import VendorProfileMenu from '../../Components/vendorprofilemenu/VendorProfileMenu'

const VenOrderDetails = () => {
    return (
        <>
             <div className={styles.myprofile}>
                <div className={styles.promenu}>
                    <VendorProfileMenu />

                </div>
                <VenOrderscomp />
            </div>
        </>
    )
}

export default VenOrderDetails